var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#C2B8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2062 6.25C17.3249 6.25 18.7499 7.7375 18.7499 9.94375V15.05C18.7499 17.2625 17.3249 18.75 15.2062 18.75H9.78744C7.66931 18.75 6.24994 17.2625 6.24994 15.05V9.94375C6.24994 7.7375 7.66931 6.25 9.78744 6.25H15.2062ZM12.4999 9.48125C12.2374 9.48125 12.0312 9.6875 12.0312 9.95V13.9188L10.4874 12.3688C10.3999 12.2812 10.2749 12.2312 10.1562 12.2312C10.0381 12.2312 9.91869 12.2812 9.82494 12.3688C9.64369 12.55 9.64369 12.85 9.82494 13.0312L12.1687 15.3875C12.3437 15.5625 12.6562 15.5625 12.8312 15.3875L15.1749 13.0312C15.3562 12.85 15.3562 12.55 15.1749 12.3688C14.9874 12.1875 14.6937 12.1875 14.5062 12.3688L12.9687 13.9188V9.95C12.9687 9.6875 12.7562 9.48125 12.4999 9.48125Z",
    fill: "#4B3BAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderInIcon);
export default __webpack_public_path__ + "static/media/order-in-icon.8d4a32787c6a75947c06083159c3412d.svg";
export { ForwardRef as ReactComponent };